export const LongerArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={44}
    viewBox="0 0 80 44"
    width={80}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M80 22.892V20.29H6.862A21.42 21.42 0 0 0 21.419 0H18.72A18.72 18.72 0 0 1 0 18.72v5.397a18.72 18.72 0 0 1 18.72 18.72h2.699A21.419 21.419 0 0 0 7.805 22.891H80ZM.216 21.42v-.002a22.671 22.671 0 0 1 0 .002Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
